































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import AddressInput from '@/components/AddressInput.vue';
import { i18n } from '@/i18n';
import { date } from 'quasar';
import formatDate = date.formatDate;
import { Action, Getter, Mutation, State } from 'vuex-class';
import { CartState } from '@/store/cart/types';
import {
  ICart,
  ICustomer,
  IFlightPassenger,
  IInvoice,
  IPlace,
  IPolicy,
  IProductFlight,
  IProductProperty,
  IProperty,
} from '@resclick/data-access';
import { WidgetState } from '@/store/widget/types';
import GuestInfo from '@/components/GuestInfo.vue';

@Component({
  components: {
    GuestInfo,
    AddressInput,
  },
})
export default class CustomerInfoStep extends Vue {
  @State('cart') cart!: CartState;
  @State('widget') widget!: WidgetState;
  @Mutation('cart/setCart') setCart!: any;
  @Action('cart/clearCart') clearCart!: any;
  @Getter('widget/stepMeta') stepMeta!: (id: number) => any;
  @Getter('widget/marketCountryId') defaultCountry!: number;
  @Getter('widget/market') market!: IPlace;
  @Getter('widget/property') property!: IProperty;
  @Getter('widget/policies') policies!: IPolicy[];

  formatDate = formatDate;
  disabled = true;

  form = this.$crsForm('orders', 'create', {
    customer: {
      name: '',
      surname: '',
      gender: 'MALE',
      email: '',
      phoneNumber: {
        countryCode: '+90',
        areaCode: '',
        number: '',
      },
      passportNumber: '',
      address: {
        line1: '',
        line2: '',
      },
    },
    invoice: {
      type: 'INDIVIDUAL',
      title: '',
      taxAdministration: '',
      taxNumber: '',
      address: {
        line1: '',
        line2: '',
      },
    },
    products: [],
  });

  acceptedTerms = {
    phoneContactPermission: false,
    kvkk: false,
    saleContract: false,
    cancellationTerms: false,
  };

  acceptedTermsModals = {
    phoneContactPermission: false,
    kvkk: false,
    saleContract: false,
    cancellationTerms: false,
  };

  get termsAndconditionsOptions() {
    return [
      { value: 'phoneContactPermission', label: `KVKK Metnini okudum ve kabul ediyorum.` },
      { value: 'saleContract', label: `Satış Sözleşmesini okudum ve kabul ediyorum.` },
      { value: 'cancellationTerms', label: `Satış Sözleşmesini okudum ve kabul ediyorum.` },
      {
        value: 'kvkk',
        label: `Bu rezervasyonun herhangi bir aşamasında işlemimin yarım kalması durumunda ${this.property.name}, formda belirtmiş olduğum iletişim bilgilerini kullanarak bana ulaşabilir.`,
      },
    ];
  }

  get kvkkPolicy() {
    return this.policies.find((p: IPolicy) => p.type === 'KVKK') || {};
  }

  get saleContractPolicy() {
    return this.policies.find((p: IPolicy) => p.type === 'SALE_CONTRACT') || {};
  }

  get cancellationTerms() {
    return this.policies.find((p: IPolicy) => p.type === 'CANCELLATION_CONDITIONS');
  }

  get genderOptions() {
    return [
      { label: i18n.t('GENERAL.MALE'), value: 'MALE' },
      { label: i18n.t('GENERAL.FEMALE'), value: 'FEMALE' },
    ];
  }

  get flights() {
    const { products = [] } = this.form.fields;
    return products.filter((product) => product.productCategory === 'FLIGHT') as IProductFlight[];
  }

  get rooms() {
    const { products = [] } = this.form.fields;

    return products.filter((product) => product.productCategory === 'PROPERTY') as IProductProperty[];
  }

  get areAllFlightsLocal() {
    const checkRoutes = (route: any) => {
      return (
        (route.arrival.country as IPlace).countryCode === 'TR' &&
        (route.departure.country as IPlace).countryCode === 'TR'
      );
    };

    return this.flights.every((product) => {
      let isLocal = false;
      if (product.outboundFlight) isLocal = product.outboundFlight.routes.every(checkRoutes);
      if (isLocal && product.returnFlight) isLocal = product.returnFlight.routes.every(checkRoutes);
      return isLocal;
    });
  }

  get customerAddressValidators() {
    return {
      country: {
        hasError: this.form.hasError('customer.address.country'),
        message: this.form.getError('customer.address.country'),
      },
      province: {
        hasError: this.form.hasError('customer.address.province'),
        message: this.form.getError('customer.address.province'),
      },
      district: {
        hasError: this.form.hasError('customer.address.district'),
        message: this.form.getError('customer.address.district'),
      },
    };
  }

  isLocalPassenger(passenger: IProductProperty['adults'][number]) {
    let isLocalPassenger = true;
    if (this.flights.length) {
      isLocalPassenger = this.areAllFlightsLocal;
    }

    if (isLocalPassenger) {
      isLocalPassenger = this.property?.address?.country === passenger.identityDocument?.citizenship;
    }

    return isLocalPassenger;
  }

  transferInfo() {
    const invoice = this.form.fields.invoice as IInvoice;
    const customer = this.form.fields.customer as ICustomer;
    invoice.type = 'INDIVIDUAL';
    if (invoice.type === 'INDIVIDUAL') {
      invoice.taxNumber = customer.passportNumber;
      invoice.title = customer.name + ' ' + customer.surname;
    }
    invoice.address = customer.address;
    this.$forceUpdate();
  }

  setFields() {
    this.form.setFields({
      company: this.widget.settings.company,
      customer: this.form.fields.customer,
      invoice: this.form.fields.invoice,
      products: this.form.fields.products,
    });
  }

  @Watch('cart.customer', { deep: true, immediate: true })
  setCustomer(value: ICart['customer']) {
    this.form.fields.customer = value as ICustomer;
    this.setFields();
  }

  @Watch('cart.invoice', { deep: true, immediate: true })
  setInvoice(value: ICart['invoice']) {
    this.form.fields.invoice = value as IInvoice;
    this.setFields();
  }

  @Watch('cart.products', { deep: true, immediate: true })
  setItems(value: ICart['products']) {
    const products: ICart['products'] = value || [];

    this.form.fields.products = products.map((product: any) => {
      const result = JSON.parse(JSON.stringify(product));
      if (result.productCategory === 'PROPERTY') {
        result.roomName = product.room?.displayName;
        result.propertyName = product.room?.property?.name;
        result.stayNights = date.getDateDiff(product.checkOutDate, product.checkInDate, 'days');
        result.ratePlan = product.ratePlan?.id || product.ratePlan;
        result.cancellationPolicy = product.cancellationPolicy?.id || product.cancellationPolicy;
        result.cancellationPolicyType = product.cancellationPolicy?.type?.name;
        result.ratePlanType = product.ratePlan?.type?.name;
      }
      return result;
    });

    this.setFields();
    if (this.rooms.length < 1) {
      this.$emit('changeStep', 0);
    }
  }

  mounted() {
    this.$set((this.form.fields.customer as any).address, 'country', this.defaultCountry);
    this.$set((this.form.fields.invoice as any).address, 'country', this.defaultCountry);

    this.rooms.forEach((room) => {
      const setDefaults = (people: any) => {
        this.$set(people.identityDocument, 'citizenship', this.defaultCountry);
        this.$set(people.identityDocument, 'issueCountry', this.defaultCountry);
        Object.defineProperty(people.identityDocument, 'type', {
          get: () => {
            return this.isLocalPassenger(people) ? 'ID' : 'PASSPORT';
          },
        });
      };
      room.adults.forEach(setDefaults);
      room.children.forEach(setDefaults);
    });
  }

  onContinue() {
    this.transferInfo();
    if (this.flights.length) {
      const passengers: IFlightPassenger[] = this.rooms.reduce((prev, room) => {
        prev.push(
          ...room.adults.map((guest) => {
            const passenger: IFlightPassenger = JSON.parse(JSON.stringify(guest));
            passenger.type = 'ADULT';
            return passenger;
          }),
        );

        prev.push(
          ...room.children.map((guest) => {
            const passenger: IFlightPassenger = JSON.parse(JSON.stringify(guest));
            passenger.type = 'CHILD';
            return passenger;
          }),
        );

        return prev;
      }, [] as IFlightPassenger[]);

      this.flights.forEach((flight) => {
        flight.passengers = passengers;
      });
    }

    this.form.submit().then((res) => {
      // this.clearCart();
      window.localStorage.setItem('orderId', res.data.id as any);
      window.localStorage.setItem('orderNumber', res.data.orderNumber as any);
      // @ts-ignore
      this.$emit('changeStep', this.stepMeta(2).next);
    });
  }

  openModal(value: string) {
    // @ts-ignore
    this.acceptedTermsModals[value] = !this.acceptedTermsModals[value];
  }

  @Watch('acceptedTerms', { deep: true, immediate: true })
  checkTerms() {
    const keys = Object.keys(this.acceptedTerms);
    let isDisabled = true;

    if (this.acceptedTerms.phoneContactPermission === false) isDisabled = true;
    else if (this.acceptedTerms.kvkk === false) isDisabled = true;
    else if (this.acceptedTerms.saleContract === false) isDisabled = true;
    else if (
      this.cancellationTerms &&
      this.cancellationTerms.isActive &&
      this.acceptedTerms.cancellationTerms === false
    ) {
      isDisabled = true;
    } else {
      isDisabled = false;
    }

    this.disabled = isDisabled;
  }
}
